import i18n from '../../lang/de/js/messages.json';


$(function () {
    'use-strict';

    function openLink(e) {
        let $el = $(e.currentTarget);
        let target = $el.attr('target');

        let $source = $($el.data('source'));
        let source = $source[0];

        if (source) {
            window.open(source.value, target);
        }
    }

    function copyToClipboard(e) {
        let $el = $(e.currentTarget);
        let type = $el.data('type');

        let $source = $($el.data('source'));
        let source = $source[0];

        if (source) {
            let textToCopy = source.value;

            // Copy the text inside the text field.
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    // Alert the copied text.
                    if ('copy_to_clipboard_' + type in i18n.success) {
                        alert(i18n.success['copy_to_clipboard_' + type]);
                    } else {
                        alert(i18n.success.copy_to_clipboard_text);
                    }
                })
              .catch(err => {
                    console.log(err);
              });
        }
    }

    $(document).on('click', '.open-link', (e) => {
        e.preventDefault();
        openLink(e);
    });

    $(document).on('click', '.copy-to-clipboard', (e) => {
        e.preventDefault();
        copyToClipboard(e);
    });
});
